import { FrontendLocations, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApiRequest } from '../models/apiRequest';
import { subscribePendingOnlineApplications, unsubscribePendingOnlineApplications } from '../pendingOnlineApplicationActions';
import { IStore, CLIENT_STORE_NAME } from '../store';

export const usePendingOnlineApplications = (location: FrontendLocations) => {
  const dispatch = useDispatch();
  const pendingOnlineApplication = useSelector((store: IStore) => store.client.intermediary.pendingOnlineApplications);
  const { error, fetching, polling } = useFrontendSubscriptionStatus(CLIENT_STORE_NAME, ApiRequest.ClientPendingOnlineApplicationsGet1);

  useEffect(() => {
    dispatch<any>(subscribePendingOnlineApplications(location));

    return () => {
      dispatch<any>(unsubscribePendingOnlineApplications(location));
    };
  }, []);

  return {
    loading: fetching && pendingOnlineApplication.unfinished.length === 0 && pendingOnlineApplication.submitted.length === 0,
    polling,
    error,
    data: {
      unfinished: pendingOnlineApplication.unfinished,
      submitted: pendingOnlineApplication.submitted
    }
  };
};
